import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
// import serviceStatusReducer from '../features/serviceStatus/serviceStatusSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    // serviceStatus: serviceStatusReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
